/* eslint-disable no-plusplus */
/* eslint-disable consistent-return */
import React from 'react'


const Globe = () => {
    const spans = [];
    for (let i = 1; i <= 300; i++) {
      spans.push(
        <span
          key={i}
          style={{
            transform: `translate3d(
            ${150 * Math.sin((i / 300) * (Math.PI)) * Math.cos((i / 300) * 90)}px, 
            ${150 * Math.sin((i / 300) * Math.PI) * Math.sin((i / 300) * 90)}px, 
            ${150 * Math.cos((i / 300) * Math.PI)}px)`,
            color:`hsl(${(i / 300) * 360}, 100%, 50%)`,
            // animationDelay: `-${(i / 300) * 7}s`,
            transformStyle: 'preserve-3d'
          }}
        />
      );
    }
    return (
        <div className="globe-parent">
            <div className='horizon-glow' />
            <div className="globe-inner">
                {spans}
            </div>
        </div>
    );
  };
  

export default Globe